import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    expireAt: {
        type: "datetime",
        label: "Post Expire On",
        isRequired: true,
        xs: 12,
        lg: 3,
        sm: 6,
        md: 3,
        minDate: new Date(),
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    }
};

export default FIELDS;